import React from 'react';
import assign from 'object-assign';
// -- lists and menus
import MenuItem from 'material-ui/MenuItem';
import { Card, CardText } from 'material-ui/Card';

// -- form components
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import DatePicker from '../Common/DatePicker';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import SelectModule from "../Module/SelectModule";
import SelectModules from '../Module/SelectModules';
import SelectCourse from "../Course/SelectCourse";
import SelectCourses from '../Course/SelectCourses';

import ReportActions from '../../actions/ReportActionCreator';
import ReportStore from '../../stores/ReportStore';
import ReportTypeStore from '../../stores/ReportTypeStore';

import FilterActions from '../../actions/FilterActionCreator';
import FilterStore from '../../stores/FilterStore';

const defined = function(e) { return e !== undefined; };
const menuById = function(item) { return <MenuItem key={item.id} value={item.id} primaryText={item.name} />; };

const ReportForm = React.createClass({

    getInitialState: function () {

        const isEdit = (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/));

        return {
            isEdit: isEdit,
            redirectTo: (isEdit ? '/dashboard/report/' + this.props.routeParams.id : '/dashboard/reports'),
            details: {
                id: '',
                name: '',
                description: '',
                type: 'progress',
                filterId: '',
                filter: '',
                reportTypeId: '',
                includeAttributes: false,
                includeExtendedInfo: false,
                includeArchivedUsers: false,
                fileOnly: false,
                shareKey: ''
            },
            canIncludeAttributes: false,
            filters: [],
            reportTypes: [],
            reportFilters: [],
            selectedType: '',
            filterFields: [],
            canExtend: {},
            moduleName: null,
            courseName: null,
            moduleIds: [],
            courseIds: []
        }
    },

    componentDidMount: function() {
        this._onSubmit = this._onSubmit.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onFiltersChange = this._onFiltersChange.bind(this);
        this._onReportTypeSelect = this._onReportTypeSelect.bind(this);
        this.setReportFilters = this.setReportFilters.bind(this);
        this._onReportTypesChange = this._onReportTypesChange.bind(this);
        this.buildFilterForm = this.buildFilterForm.bind(this);

        ReportTypeStore.addChangeListener(this._onReportTypesChange);
        ReportActions.getReportTypes();

        FilterStore.addChangeListener(this._onFiltersChange);
        FilterActions.getAll();

        if (this.state.isEdit) {
            ReportStore.addChangeListener(this._onChange);
            ReportActions.getById(this.props.routeParams.id);
        }
    },

    componentWillUnmount: function() {
        if (this.state.isEdit) {
            ReportStore.removeChangeListener(this._onChange);
        }
        ReportTypeStore.removeChangeListener(this._onReportTypesChange);
        FilterStore.removeChangeListener(this._onFiltersChange);
    },

    render: function () {

        let formProps = {
            title: this.state.isEdit ? this.state.details.name : 'New report',
            onSave: this._onSubmit,
            redirectTo: this.state.redirectTo
        };

        return(

            <Form {...formProps} >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:80"
                            validationError="Please use only numbers and letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            validations="maxLength:120"
                            validationError="Please use only numbers and letters"
                            hintText="Description"
                            floatingLabelText="Description"
                        />
                        <SelectField
                            name="reportType"
                            value={this.state.details.reportTypeId}
                            hintText="Report"
                            floatingLabelText="Report"
                            onChange={this._onReportTypeSelect}
                            required
                        >
                            {this.state.reportTypes}
                        </SelectField>
                        <SelectField
                            name="filter"
                            value={this.state.details.filterId}
                            hintText="Filter"
                            floatingLabelText="Filter"
                            required
                        >
                            {this.state.filters}
                        </SelectField>
                        <div>
                            <h2>Options</h2>
                        </div>
                        <div className="cent-checkbox-wrapper">
                            <Checkbox
                                name="fileOnly"
                                value={this.state.details.fileOnly}
                                label="File download only"
                                onCheck={(e, value) => this.setState({
                                    details: {
                                        ...this.state.details,
                                        fileOnly: value
                                    }
                                })}
                            />
                        </div>
                        <div className="cent-checkbox-wrapper">
                            <Checkbox
                                name="includeArchivedUsers"
                                value={this.state.details.includeArchivedUsers}
                                label="Include archived users"
                                onCheck={(e, value) => this.setState({
                                    details: {
                                        ...this.state.details,
                                        includeArchivedUsers: value
                                    }
                                })}
                            />
                        </div>
                        {!!this.state.canExtend[this.state.selectedType] && (
                            <div>
                                <h2>Export</h2>
                                <p className="subHeading">Export to include additional data</p>
                            </div>
                        )}
                        {!!this.state.canExtend[this.state.selectedType] && (
                            <div className="cent-checkbox-wrapper">
                                <Checkbox
                                    name="includeAttributes"
                                    value={this.state.details.includeAttributes}
                                    label="User attributes"
                                    onCheck={(e, value) => this.setState({
                                        details: {
                                            ...this.state.details,
                                            includeAttributes: value
                                        }
                                    })}
                                />
                            </div>
                        )}
                        {!!this.state.canExtend[this.state.selectedType] && (
                            <div className="cent-checkbox-wrapper">
                                <Checkbox
                                    name="includeExtendedInfo"
                                    value={this.state.details.includeExtendedInfo}
                                    label="Extended user details"
                                    onCheck={(e, value) => this.setState({
                                        details: {
                                            ...this.state.details,
                                            includeExtendedInfo: value
                                        }
                                    })}
                                />
                            </div>
                        )}
                        {(!!this.state.selectedType && !!this.state.filterFields[this.state.selectedType]) && (
                            <div>
                                <br />
                                <h2>Filters</h2>
                                <p className="subHeading">Apply the following filters to the report results</p>
                                {this.state.filterFields[this.state.selectedType]}
                            </div>
                        )}
                        <br />
                    </CardText>
                </Card>
            </Form>
        );
    },

    _onSubmit: function (model) {
        if (!!this.state.moduleName) {
            model.reportFilters['moduleName'] = this.state.moduleName;
        }
        if (!!this.state.courseName) {
            model.reportFilters['courseName'] = this.state.courseName;
        }
        if (!!this.state.moduleIds.length) {
            model.reportFilters['moduleIds'] = this.state.moduleIds;
        }
        if (!!this.state.courseIds.length) {
            model.reportFilters['courseIds'] = this.state.courseIds;
        }

        if (this.state.isEdit) {
            return ReportActions.update(this.props.routeParams.id, model);
        } else {
            return ReportActions.save(model);
        }
    },

    _onChange: function() {
        const details = ReportStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details, moduleIds: details.reportFilters.moduleIds || []});
            this.setReportFilters(this.state.details.reportTypeId);
        }
    },

    _onFiltersChange: function() {
        const filters = FilterStore.getAll();
        if (filters !== undefined) {
            let filterData = filters.filter(defined).map(menuById);
            let state = assign(this.state, {filters: filterData});
            this.setState(state);
        }
    },

    _onReportTypeSelect: function(e, v) {
        if (this.state.selectedType !== v) {
            this.setReportFilters(v);
        }
    },

    setReportFilters: function(typeId) {
        let state = assign({}, this.state, {selectedType: typeId});
        const fields = this.state.reportFilters.find(function(e) { return e !== undefined && e.id === typeId; });
        if (!!fields) {
            state.filterFields[typeId] = this.buildFilterForm(fields.filters);
        }
        this.setState(state);
    },

    _onReportTypesChange: function() {
        const types = ReportTypeStore.getAll();
        if (types !== undefined) {
            const definedTypes = types.filter(defined);
            const reportTypes = definedTypes.sort((a, b) => (a.name.localeCompare(b.name))).map(menuById);
            const reportFilters = definedTypes.map(({id, filters}) => ({id, filters: filters || []}));
            const canExtend = definedTypes.reduce((ac, {id, extensible}) => ({...ac, [id]: extensible}), {});
            this.setState({reportTypes, reportFilters, canExtend});
            if (!!this.state.details.reportTypeId) {
                this.setReportFilters(this.state.details.reportTypeId);
            }
        }
    },

    style: {
        leftField: {
            width: '49%',
            display: 'inline-block',
            marginRight: '2%'
        },
        rightField: {
            width: '49%',
            display: 'inline-block'
        }
    },
    
    buildFilterForm: function(fields) {
        const elements = [];
        fields.forEach((field, i) => {
            // if value selected, add.
            const data = (this.state.details.reportFilters || {});
            let fieldProps;
            switch (field.type) {
                case 'text':
                    if (field.field === 'moduleName') {
                        elements.push(
                            <SelectModule
                                label={field.name}
                                name={`reportFilters[${field.field}]`}
                                onSelect={(name) => this.setState({moduleName: name})}
                                clearOnSelect={false}
                            />
                        );
                    } else if (field.field === 'courseName') {
                        elements.push(
                            <SelectCourse
                                label={field.name}
                                name={`reportFilters[${field.field}]`}
                                onSelect={(name) => this.setState({courseName: name})}
                                clearOnSelect={false}
                            />
                        );
                    } else {
                        fieldProps = {
                            key: i,
                            name: `reportFilters[${field.field}]`,
                            hintText: field.name,
                            floatingLabelText: field.name
                        };
                        if (data.hasOwnProperty(field.field)) {
                            fieldProps.value = data[field.field];
                        }
                        elements.push(<TextField {...fieldProps} />);
                    }

                    break;
                case 'daterange':
                    // from
                    const fromFieldName = `${field.field}From`;
                    const fromValue = data[fromFieldName] ? new Date(data[fromFieldName]) : null;
                    fieldProps = {
                        key: `from${i}`,
                        name: `reportFilters[${fromFieldName}]`,
                        value: fromValue,
                        hintText: `${field.field} From`,
                        floatingLabelText: `${field.field} From`,
                        style: this.style.leftField
                    };
                    elements.push(<DatePicker {...fieldProps} />);

                    // to
                    const toFieldName = `${field.field}To`;
                    const toValue = data[toFieldName] ? new Date(data[toFieldName]) : null;
                    fieldProps = {
                        key: `to${i}`,
                        name: `reportFilters[${toFieldName}]`,
                        value: toValue,
                        hintText: `${field.field} To`,
                        floatingLabelText: `${field.field} To`,
                        style: this.style.rightField
                    };

                    elements.push(<DatePicker {...fieldProps} />);
                    break;
                    
                case 'multiselect':
                    if (field.field === 'moduleIds') {
                        elements.push(
                            <SelectModules
                                moduleIds={data.hasOwnProperty(field.field) ? data[field.field] : []}
                                onSelect={(name, id) => this.setState({moduleIds: [...this.state.moduleIds, id]})}
                                onDelete={(moduleId) => this.setState({moduleIds: this.state.moduleIds.filter((id) => (moduleId) !== id)})}
                            />
                        );
                    } else if (field.field === 'courseIds'){
                        elements.push(
                          <SelectCourses
                              courseIds={data.hasOwnProperty(field.field) ? data[field.field] : []}
                              onSelect={(name, id) => this.setState({courseIds: [...this.state.courseIds, id]})}
                              onDelete={(courseId) => this.setState({courseIds: this.state.courseIds.filter((id) => (courseId) !== id)})}
                          />
                        );
                    }
                    break;

                default:
                    break;
            }
        }, this);
        return elements;
    }

});

export default ReportForm;

